<ng-container *ngIf="hasActiveSession; else noSession">
    <div class="wrapper">
        <div class="wrapper__header">
            <app-header></app-header>
            <app-breadcrumbs></app-breadcrumbs>
        </div>
        <div class="wrapper__body">
            <div class="wrapper">
                <div class="content">
                    <app-menu></app-menu>
                    <div class="content__body">
                        <div class="content__title">
                            <h2>{{ pageSectionName }}</h2>
                        </div>
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>        
        </div>
        <div class="wrapper__footer">
            <app-footer></app-footer>
        </div>
    </div>
    <loader></loader>
    <app-toast #toast></app-toast>
</ng-container>

<ng-template #noSession>
    <div>Loading...</div>
</ng-template>
